import React from 'react'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import { Tabs, Tab, AppBar, Box, IconButton, Button } from '@material-ui/core'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import { ListingConsumer, ListingProvider } from '../../context/ListingContext'
import { useStyles } from './Styles'
import CodesAllUsageContent from './AllUsage'
import { LanguageConsumer } from '../../context/LanguageContext'
import AddNewForm from '../../FormFields/EntityAddForm'
import AddNewDialog from '../Dialog/AddNewDialog'
import EditIcon from '@material-ui/icons/Edit'
import BackupIcon from '@material-ui/icons/Backup'
import { SingleCodeProvider, SingleCodeConsumer } from '../../context/SingleCodeContext'
import CodeDetails from './CodeDetails'
import CodesRequestsApprovalContent from './RequestsApproval'
import CookiesStorageService from '../../Services/CookiesStorageService'

function TabPanel (props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box py={3}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps (index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`
  }
}

const CodesPageContent = () => {
  const classes = useStyles()
  // const intl = useIntl()
  const [tabValue, setTabValue] = React.useState(0)
  const [tabEntityName, setTabEntityName] = React.useState('codesUsage')

  const handleChange = (event, newValue) => {
    setTabValue(newValue)
    setTabEntityName(!!newValue ? 'codeRequests' : 'codesUsage')
  }

  return (
    <ListingProvider entityName={tabEntityName} codePagination>
      <ListingConsumer>
        {({
            listingData, handleNeedRefreshListingData,
            currentDialogAction, currentSelectedRow, dialogActionSubmit, cancelDialog, isDialogOpen, openDialog, entityName
          }) => (
          <>
            <PageTitle title={<FormattedMessage id='CodesPageContent.PageTitle'/>}
                       addNewButton={true}
                       addButtonFunction={() => openDialog()}
                       addButtonText={<FormattedMessage id='CodesPage.addNew'/>}
                       addButtonIcon={<AddOutlinedIcon/>}
                       extraButtons={
                         <Button size={'large'} variant={'contained'} color={'primary'}
                                 onClick={() => openDialog('codesBulkImport')}
                                 className={classes.codesBulkImport} startIcon={<BackupIcon/>}>
                           <FormattedMessage id='CodesPage.BulkImport'/>
                         </Button>}/>

            <SingleCodeProvider shouldUpdate={handleNeedRefreshListingData}>
              <SingleCodeConsumer>
                {({ currentCodeData, updateCode, cancelCodeDialog, isCodeDialogOpen, openCodeDialog, loadCodeData, clearCodeData, currentCodeLoading, getCurrentCodeDataFromListing, bulkImportCodes }) => (
                  <LanguageConsumer>
                    {({ locale }) => (
                      <>
                        <AddNewDialog
                          children={<>
                            {currentDialogAction === 'show' ?
                              <CodeDetails
                                code={tabEntityName === 'codeRequests' ? currentSelectedRow?.itemCode || '' : currentSelectedRow?.codeLookupValue || ''}
                                type={tabEntityName === 'codeRequests' ? currentSelectedRow?.codeTypeName || '' : currentSelectedRow?.codeTypeNamePrimaryLang || ''}
                                requesterTaxpayer={currentSelectedRow?.requesterTaxpayer || {}}
                                ownerTaxpayer={currentSelectedRow?.ownerTaxpayer || {}}
                                status={currentSelectedRow?.status || ''}
                                currentSelectedRow={currentSelectedRow}
                                locale={locale}
                                getCurrentCodeDataFromListing={() => getCurrentCodeDataFromListing(currentSelectedRow)}
                                getCodeData={loadCodeData}/> :
                              <AddNewForm
                                entityName={currentDialogAction === 'codesBulkImport' ? 'codesBulkImport' : (currentSelectedRow?.status?.toString() === 'Approved' ? 'EGSCodeUsage' : 'codeUsage')}
                                codeUsageRequestID={currentSelectedRow?.codeUsageRequestID || ''}
                                codeUsageUniqueID={tabEntityName === 'codeRequests' ? currentSelectedRow?.itemCode || '' : currentSelectedRow?.codeLookupValue || ''}
                                currentData={currentCodeData}
                                currentCodeLoading={currentCodeLoading}
                                onSubmit={currentDialogAction === 'codesBulkImport' ? bulkImportCodes : (currentDialogAction === 'edit' ? updateCode : dialogActionSubmit)}
                                currentAction={currentDialogAction}
                                updateParentEntity={cancelDialog}
                                cancelDialog={() => cancelDialog(null, clearCodeData)}/>
                            }

                            {tabEntityName === 'codeRequests' &&
                            currentSelectedRow?.ownerTaxpayer?.rin?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString() &&
                            ['Submitted', 'Approved'].includes(currentSelectedRow?.status?.toString()) &&
                            <AddNewDialog
                              children={
                                <AddNewForm
                                  entityName={currentSelectedRow?.status?.toString() === 'Submitted' ? 'codeUsage' : 'EGSCodeUsage'}
                                  codeUsageRequestID={currentSelectedRow?.codeUsageRequestID || ''}
                                  codeUsageUniqueID={currentSelectedRow?.itemCode || ''}
                                  currentData={currentCodeData}
                                  onSubmit={updateCode}
                                  currentAction={'edit'}
                                  cancelDialog={cancelCodeDialog}/>
                              }
                              dialogAction={'edit'}
                              DialogTitle={<FormattedMessage id={`codes.dialogTitle.edit`}
                                                             values={{
                                                               type: currentSelectedRow?.codeTypeName || '',
                                                               code: currentSelectedRow?.itemCode || ''
                                                             }}/>}
                              isDialogOpen={isCodeDialogOpen}
                              cancelDialog={cancelCodeDialog}
                            />
                            }
                          </>}
                          dialogAction={currentDialogAction}
                          modifyFunction={tabEntityName === 'codeRequests' && currentSelectedRow?.ownerTaxpayer?.rin?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString() &&
                          ['Submitted', 'Approved'].includes(currentSelectedRow?.status?.toString()) && !!currentSelectedRow?.active ? () => openCodeDialog(currentSelectedRow?.codeUsageRequestID || '') : null}
                          DialogTitle={<FormattedMessage id={`codes.dialogTitle.${currentDialogAction}`}
                                                         values={{
                                                           type: tabEntityName === 'codeRequests' ? currentSelectedRow?.codeTypeName || '' : currentSelectedRow?.codeTypeNamePrimaryLang || '',
                                                           code: tabEntityName === 'codeRequests' ? currentSelectedRow?.itemCode || '' : currentSelectedRow?.codeLookupValue || '',
                                                           editLink: tabEntityName === 'codeRequests' &&
                                                           currentSelectedRow?.ownerTaxpayer?.rin?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString() &&
                                                           ['Submitted', 'Approved'].includes(currentSelectedRow?.status?.toString()) && !!currentSelectedRow?.active ?
                                                             <IconButton color="secondary" aria-label="Edit"
                                                                         className={classes.editBtn}
                                                                         onClick={openCodeDialog}>
                                                               <EditIcon/>
                                                             </IconButton> : ''
                                                         }}/>}
                          isDialogOpen={isDialogOpen}
                          cancelDialog={() => cancelDialog(null, clearCodeData)}
                        />

                        <div className={classes.tabsWrapper}>
                          <AppBar position="static" color="default">
                            <Tabs
                              value={tabValue}
                              onChange={handleChange}
                              variant="standard"
                              indicatorColor="secondary"
                              textColor="secondary"
                            >
                              <Tab label={<FormattedMessage id='CodesPage.tabs.allUsage'/>} {...a11yProps(0)} />
                              <Tab label={<FormattedMessage id='CodesPage.tabs.approvalDetails'/>} {...a11yProps(1)} />
                            </Tabs>
                          </AppBar>
                          <TabPanel value={tabValue} index={0}>
                            <CodesAllUsageContent listingData={listingData} locale={locale} openDialog={openDialog}/>
                          </TabPanel>
                          <TabPanel value={tabValue} index={1}>
                            <CodesRequestsApprovalContent listingData={listingData} locale={locale}
                                                          loadCodeData={loadCodeData}
                                                          openDialog={openDialog}/>
                          </TabPanel>
                        </div>
                      </>
                    )}
                  </LanguageConsumer>
                )}
              </SingleCodeConsumer>
            </SingleCodeProvider>
          </>
        )}
      </ListingConsumer>
    </ListingProvider>
  )
}

export default CodesPageContent
